<template>
  <el-container>
    <el-main>
      <el-row class="filter-header" :gutter="20" :class="panel.search ? 'open': ''">
        <el-col>
          <el-select v-model="capitalTypeName" clearable @change="isSelectHandle" placeholder="请选择科目">
            <el-option
              v-for="(item, index) in capitalType"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
          <el-select v-model="params.pay_type" clearable @change="isSelectHandle" placeholder="请选择支付类型">
            <el-option
              v-for="(item, index) in payType"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
          <el-date-picker
            v-model="dateTime"
            type="datetimerange"
            :picker-options="pickerOptions"
            start-placeholder="开始日期时间"
            ange-separator="至"
            end-placeholder="结束日期时间"
            align="left"
            @change="dateChange"
            placeholder="选择日期时间范围">
          </el-date-picker>
          <el-button type="primary" @click="exportData" v-loading="exportloading" style="margin-left: 10px">导出流水</el-button>
          <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
            content="导出任务会以队列执行，点击导出后，请至‘设置-导出列表’页面中查看及下载数据">
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
          <el-button class="collapse-btn" type="text" @click="panelCollapse('search')">
            <span v-if="!panel.search">更多筛选项 <i class="el-icon-arrow-down"></i></span>
            <span v-else>收起 <i class="el-icon-arrow-up"></i></span>
          </el-button>
        </el-col>
        <el-col v-show="panel.search">
          <el-input class="input-m mt10" placeholder="流水标识" v-model="params.flow_id" clearable @clear="numberSearch" @change="getAdaPayCapitalList(1)"></el-input>
          <!-- <el-input class="input-m mt10" placeholder="ACM订单号" v-model="params.acm_order_code" clearable @clear="numberSearch" @change="getAdaPayCapitalList(1)"></el-input> -->
          <el-input class="input-m mt10" placeholder="补购订单号" v-model="params.order_id" clearable @clear="numberSearch" @change="getAdaPayCapitalList(1)"></el-input>
          <el-input class="input-m mt10" placeholder="AppleID" v-model="params.shop_code" clearable @clear="numberSearch" @change="getAdaPayCapitalList(1)"></el-input>
          <el-input class="input-m mt10" placeholder="店铺名称" v-model="params.shop_name" clearable @clear="numberSearch" @change="getAdaPayCapitalList(1)"></el-input>
        </el-col>
        <el-col v-show="panel.search"  v-if="login_type === 'disti'">
          <el-input class="input-m mt10" placeholder="经销商名称" v-model="params.dealer_name" clearable @clear="numberSearch" @change="getAdaPayCapitalList(1)"></el-input>
          <el-input class="input-m mt10" placeholder="经销商HQID" v-model="params.dealer_hqid" clearable @clear="numberSearch" @change="getAdaPayCapitalList(1)"></el-input>
          <el-input class="input-m mt10" placeholder="分销商HQID" v-model="params.distributor_hqid" clearable @clear="numberSearch" @change="getAdaPayCapitalList(1)"></el-input>
          <!-- <el-input class="input-m mt10" placeholder="分销商VAD" v-model="params.distributor_vad" clearable @clear="numberSearch" @change="getAdaPayCapitalList(1)"></el-input> -->
          <!-- <el-input class="input-m mt10" placeholder="渠道RTM" v-model="params.channel_rtm" clearable @clear="numberSearch" @change="getAdaPayCapitalList(1)"></el-input> -->
        </el-col>
      </el-row>
      <el-table v-loading="loading" :data="capitalList" border :row-class-name="tableRowClassName">
        <el-table-column prop="flow_id" label="流水标识" align="center" show-overflow-tooltip fixed width="200"></el-table-column>
        <el-table-column prop="shop_code" label="AppleID" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="shop_name" label="店铺名称" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="dealer_name" label="经销商名称" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="dealer_hqid" label="经销商HQID" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="distributor_hqid" label="分销商HQID" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="bind_sn" label="绑定SN" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="bind_status_cn" label="绑定状态" align="center" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="order_id" label="补购单号" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="acm_order_code" label="ACM单号" align="center" show-overflow-tooltip></el-table-column>

        <el-table-column prop="buy_method" label="购买方式" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.buy_method === 'BUY_IN'">补购</span>
            <span v-if="scope.row.buy_method === 'RENEW_BUY'">续购</span>
            <span v-if="scope.row.buy_method === 'ORDER_BUY'">订单购买</span>
          </template>
        </el-table-column>
        <el-table-column prop="capital_type" label="科目" align="center" show-overflow-tooltip fixed="right" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.capital_type === 'trade'">入账</span>
            <span v-if="scope.row.capital_type === 'refund'">出账</span>
            <span v-if="scope.row.capital_type === 'cash'">出账</span>
          </template>
        </el-table-column>
        <el-table-column prop="pay_type" label="支付类型" align="center" show-overflow-tooltip fixed="right" width="80">
          <template slot-scope="scope">
            {{ scope.row.pay_type | payTypeLabel(scope.row) }}
          </template>
        </el-table-column>

        <el-table-column prop="capital_money" label="流水金额" align="center" show-overflow-tooltip fixed="right" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.capital_type === 'trade'">+</span>
            <span v-else>-</span>
            {{ scope.row.flow_amount  / 100 }} 元
          </template>
        </el-table-column>
        <el-table-column prop="capital_time" label="流水时间" align="center" show-overflow-tooltip fixed="right" width="160">
          <template slot-scope="scope">{{ scope.row.flow_time | datetime('yyyy-MM-dd hh:mm:ss') }}</template>
        </el-table-column>
      </el-table>
      <div class="content-padded content-center">
        <el-pagination
          small
          background
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="handleCapitalCurrentChange"
          @size-change="handleCapitalSizeChange"
          :current-page.sync="params.page"
          :total="capitalTotalCount"
          :pager-count="5"
          :page-size="params.pageSize"
          :page-sizes="[15, 50, 150, 200]"
        >
        </el-pagination>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import {orderAcsFundflow} from '@/api/trade';
import { CAPITAL_PAY_TYPE_OPTIONS } from '@/utils/payType'

export default {
  data() {
    return {
      loading:false,
      dateTime: [],
      deliveryInfo: [],
      deliveryLoading: true,

      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const start = new Date();
            const end = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            end.setTime(end.getTime() - 3600 * 1000 * 24 * 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const start = new Date();
            const end = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
            end.setTime(end.getTime() - 3600 * 1000 * 24 * 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const start = new Date();
            const end = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
            end.setTime(end.getTime() - 3600 * 1000 * 24 * 0);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      panel: {
        search: false,
      },
      exportloading: false,
      capitalType: [
        {name: '全部', value: ''},
        {name: '出账', value: 'outcome'},
        {name: '入账', value: 'income'}
      ],
      payType: CAPITAL_PAY_TYPE_OPTIONS,
      capitalTypeName: '',

      isExport: false,
      params: {
        page: 1,
        pageSize: 15,
        flow_id: '',
        capital_type: '',
        start_time: '',
        end_time: '',
        order_id: '',
        distributor_name: '',
        dealer_name: '',
        dealer_hqid: '',
        distributor_hqid: '',
        distributor_vad: '',
        channel_rtm: '',
        pay_type: '',
        acm_order_code: ''
      },
      capitalList: [],
      capitalTotalCount: 0,
    };
  },
  mounted() {
    let start = new Date(), end = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24);
    end.setTime(end.getTime());
    this.dateTime = [start, end];
    this.params.start_time = start;
    this.params.end_time = end;

    this.getAdaPayCapitalList();
  },
  methods: {
    tableRowClassName({row, rowIndex}) {
      if (row.capital_type !== 'trade') {
        return 'warning-row';
      }
      return '';
    },
    dateChange(val) {
      console.log(val, 'Change=date');
      if (val) {
        this.params.start_time = val[0];
        this.params.end_time = val[1];
      } else {
        this.params.start_time = '';
        this.params.end_time = '';
      }
      this.getAdaPayCapitalList()
    },
    getParams() {
      switch (this.capitalTypeName) {
        case 'income':
          this.params.capital_type = 'trade';
          break;
        case 'outcome':
          this.params.capital_type = ['refund', 'cash'];
          break;
        default:
          this.params.capital_type = '';
          break;
      }
    },
    getAdaPayCapitalList(page = 0) {
      if (page) {
        this.params.page = page;
      }
      this.loading = true;
      this.getParams();
      orderAcsFundflow(this.params).then((response) => {
        console.log("🚢 ~ 当前打印的内容 ~ response:", response);
        if (response.data.data.list) {
          this.capitalList = response.data.data.list
          this.capitalTotalCount = response.data.data.total_count
          this.loading = false;
        }
      });
    },
    handleCapitalCurrentChange(page_num) {
      this.params.page = page_num;
      this.getAdaPayCapitalList();
    },
    handleCapitalSizeChange(pageSize) {
      this.params.page = 1
      this.params.pageSize = pageSize
      this.getAdaPayCapitalList();
    },
    isSelectHandle() {
      this.params.page = 1
      this.getAdaPayCapitalList();
    },

    numberSearch() {
      this.params.page = 1
      this.getAdaPayCapitalList()
    },
    panelCollapse(name) {
      this.panel[name] = !this.panel[name]
    },
    exportData() {
      this.exportloading = true
      if (this.capitalList.length <= 0) {
        this.$message({
          type: 'error',
          message: '请确认导出的内容暂无数据~！'
        });
        this.exportloading = false
        return;
      }
      orderAcsFundflow({...this.params, is_export: true}).then(response => {
        if (response.data.data.status) {
          this.$message({
            type: 'success',
            message: '已加入执行队列，请在设置-导出列表中下载'
          })
          this.exportloading = false;
          return true;
        } else if (response.data.data.url) {
          this.downloadUrl = response.data.data.url
          this.downloadName = response.data.data.filename
          this.downloadView = true
        } else {
          this.$message({
            type: 'error',
            message: '无内容可导出 或 执行失败，请检查重试'
          })
          return false;
        }
      }).catch(error => {
        this.exportloading = false
        console.log(error);
        return false;
      });
    },
  },
};
</script>
